import Slider from 'react-slick'
import { styled } from '../../Styles/stitches.config'

export const StyledCarousel = styled(Slider, {
    '.slick-track': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',

        '.slick-slide': {
            '& > div': {
                display: 'flex',
                justifyContent: 'center',
            },

            '&:disabled': {
                bc: '$primary400',
                bgc: '$teritary',
                color: '$primary400',
            },
        },
    },

    '.slick-arrow': {
        bgc: '$white',
        border: '1px solid $primary600',
        br: '$1',
        color: '$primary600',
        cursor: 'pointer',
        p: '$1',
        position: 'absolute',
        top: '50%',
        transform: 'translate(0, -50%)',
        transition: '$default',

        '&:hover': {
            color: '$primary600',
            opacity: 0.8,

            '@mobile': {
                bgc: 'inherit',
            },

            '@desktop': {
                bgc: '$primary200',
            },
        },

        '&.slick-disabled': {
            bgc: 'transparent',
            bc: '$primary400',
            color: '$primary400',
            cursor: 'default',
            pointerEvents: 'none',
        },
    },

    '@mobile': {
        m: '0 32px',

        '.slick-slide > div': {
            px: '$1',
        },

        '.slick-arrow': {
            size: 24,

            '&.slick-prev': {
                left: -32,
            },

            '&.slick-next': {
                right: -32,
            },
        },
    },

    '@desktop': {
        m: '0 44px',

        '.slick-slide > div': {
            px: '$1',
        },

        '.slick-arrow': {
            size: 24,

            '&.slick-prev': {
                left: -44,
            },

            '&.slick-next': {
                right: -44,
            },
        },
    },
})

export const CarouselWrapper = styled('div', {
    overflow: 'hidden',
})
